import $ from 'jquery';
import _ from 'underscore';
import UI from 'root/ui';
import Constants from 'root/constants';
import Cache from 'root/cache';
import Util from 'root/module/util';
import Modals from 'root/modals';
import View from 'view/base';

var Feedback_Share = View.extend({
    className: 'feedback-share-dialog',
    events: {
        'click .box-url-share'                : 'copyLink',
        'click .add-email-note'               : 'addEmailNote',
        'click .switch-on'                    : 'toggleSetting',
        'click .switch-off'                   : 'toggleSetting',
        'click .purchase-video'               : 'upgradeAccount',
        'click .upgrade-plan'                 : 'upgradeAccount',
        'click .email-send'                   : 'sendEmail',
        'click .settings-save'                : 'saveSettings',
        'click .approver-row'                 : 'selectApprover',
        'click .approver-save'                : 'saveApprovers',
        'click #apply_to_all'                 : 'checkFormChange',
        'click input[name="notify_approver"]' : 'checkFormChange',
        'click .invite-people'                : 'invitePeople',
        'click .suggestion'                   : 'suggestion'
    },

    dom_handlers: {
        copyLink: function(e) {
            var link = $(e.currentTarget).text();

            Util.copyText(link, () => {
                this.$el.find('.copy-success').show();

                setTimeout(() => {
                    this.$el.find('.copy-success').hide();
                }, 4000);
            });
        },

        addEmailNote: function(e) {
            this.$el.find('.email-note').toggle();
            this.$el.find('.email-note textarea').focus();
            this.$el.find('.add-email-note').toggleClass('open');
        },

        toggleSetting: function(e) {
            if ($(e.currentTarget).hasClass('switch-on')) {
                $(e.currentTarget).removeClass('switch-on').addClass('switch-off');
            } else {
                $(e.currentTarget).removeClass('switch-off').addClass('switch-on');
            }

            if ($(e.currentTarget).hasClass('allow-approval')) {
                this.$el.find('.approver-row.selected').click();
            }

            this.checkFormChange();

            this.renderPublicAccessHelp();
        },

        upgradeAccount: function(e) {
            e.preventDefault();
            Modals.choosePlan();
        },

        sendEmail: function(e) {
            var emails = [];
            var valid  = true;

            var email_input = this.$el.find('input[name="email"]');
            var email_value = email_input.val().trim();
            $(email_value.split(/[(,)( )(\r\n)(\r)(\n)]+/)).each(function(index, email) {
                email = email.trim();
                if (email.match(/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/) && !email.match(/qq\.com/) && !email.match(/163\.com/)) {
                    emails.push(email);
                } else {
                    email_input.get(0).selectionStart = email_value.indexOf(email);
                    email_input.get(0).selectionEnd   = email_value.indexOf(email) + email.length;
                    email_input.focus();

                    valid = false;
                    return false;
                }
            });

            if (!valid || !emails.length) {
                return;
            }

            var limit = Cache.account.get('is_trial') || Cache.account.isFreePlan() ? 1 : 10;

            if (emails.length > limit) {
                if (limit === 1) {
                    UI.error('Please enter a valid email address.');
                } else {
                    UI.error('You can only share with ' + limit + ' people at a time.');
                }
                return;
            }

            var note = this.$el.find('textarea[name="note"]').val().trim();

            var button = $(e.currentTarget);
            button.addClass('loading').prop('disabled', true);

            Cache.app.request({
                action: 'feedback/share',
                context: this,
                data: {
                    id: this.model.id,
                    emails: emails,
                    note: note
                },
                success: function(response) {
                    UI.success('Email sent');

                    this.trigger('Submit:Success');
                },
                complete: function() {
                    button.removeClass('loading').prop('disabled', false);
                }
            });
        },

        saveSettings: function(e) {
            var link_settings = this.getLinkSettings();

            var button = this.$el.find('.settings-save').addClass('loading').prop('disabled', true);

            Cache.app.request({
                action: 'feedback/updateShareSettings',
                context: this,
                data: {
                    id                   : this.model.id,
                    is_shared            : link_settings.is_shared,
                    allow_public_comment : link_settings.allow_public_comment,
                    allow_video_feedback : link_settings.allow_video_feedback,
                    apply_to_all         : link_settings.apply_to_all
                },
                success: function(response) {
                    this.model.set({
                        'is_shared'            : link_settings.is_shared,
                        'allow_public_comment' : link_settings.allow_public_comment,
                        'allow_video_feedback' : link_settings.allow_video_feedback
                    });

                    if (link_settings.apply_to_all) {
                        Cache.feedback.each(function(model) {
                            model.set({
                                'is_shared'            : link_settings.is_shared,
                                'allow_public_comment' : link_settings.allow_public_comment,
                                'allow_video_feedback' : link_settings.allow_video_feedback
                            });

                            if (Cache.getDefaultProject()) {
                                Cache.getDefaultProject().set({
                                    'feedback_is_shared'            : link_settings.is_shared,
                                    'feedback_allow_public_comment' : link_settings.allow_public_comment,
                                    'feedback_allow_video_feedback' : link_settings.allow_video_feedback
                                });
                            }
                        });
                    }

                    UI.success('Share settings updated');

                    this.trigger('Submit:Success');
                },
                complete: function() {
                    button.removeClass('loading').prop('disabled', false);
                }
            });
        },

        selectApprover: function(e) {
            if ($(e.target).prop('tagName').toUpperCase() === 'INPUT') {
                return;
            }

            if ($(e.target).prop('tagName').toUpperCase() === 'LABEL') {
                return;
            }

            if ($(e.currentTarget).hasClass('disabled')) {
                return;
            }

            this.$el.find('.approver-row').not($(e.currentTarget)).removeClass('selected');
            $(e.currentTarget).toggleClass('selected');

            this.checkFormChange();
        },

        saveApprovers: function(e) {
            var form_settings = this.getApprovalSettings();

            var button = this.$el.find('.approver-save').addClass('loading').prop('disabled', true);

            Cache.app.request({
                action: 'feedback/setApprover',
                context: this,
                data: {
                    id       : this.model.id,
                    user_ids : form_settings.user_ids,
                    notify   : form_settings.notify
                },
                success: function(response) {
                    _.each(Cache.feedback_approver.where({feedback_id: this.model.id}), function(model) {
                        Cache.feedback_approver.remove(model);
                    });

                    Cache.feedback_approver.add(response);

                    if (form_settings.user_ids.length) {
                        _.each(Cache.feedback_screenshot.where({feedback_id: this.model.id}), function(model) {
                            model.set('is_approved', false);
                        });
                    }

                    UI.success('Approval settings updated');

                    this.trigger('Submit:Success');
                },
                complete: function() {
                    button.removeClass('loading').prop('disabled', false);
                }
            });
        },

        checkFormChange: function() {
            this.checkFormChange();
        },

        invitePeople: function(e) {
            e.preventDefault();
            this.trigger('Invite:People');
        },

        suggestion: function(e) {
            e.preventDefault();
            Cache.app.dispatcher.trigger('contactUs');
        }
    },

    initialize: function(options) {
        this.hide_share = !!options.hide_share;
    },

    checkFormChange: function() {
        // settings tab
        var link_settings = this.getLinkSettings();
        var link_has_change = false;

        if (link_settings.apply_to_all) {
            link_has_change = true;
        } else if (link_settings.is_shared !== this.model.get('is_shared')) {
            link_has_change = true;
        } else if (link_settings.allow_public_comment !== this.model.get('allow_public_comment')) {
            link_has_change = true;
        }

        // approval tab
        var approval_settings = this.getApprovalSettings();
        var approval_has_change = false;

        var user_ids = [];
        _.each(Cache.feedback_approver.where({feedback_id: this.model.id}), function(model) {
            user_ids.push(model.get('user_id'));
        });

        if (_.difference(user_ids, approval_settings.user_ids).length || _.difference(approval_settings.user_ids, user_ids).length) {
            approval_has_change = true;
        } else if (approval_settings.notify) {
            approval_has_change = true;
        }

        this.$el.find('.settings-save').prop('disabled', !link_has_change);
        this.$el.find('.approver-save').prop('disabled', !approval_has_change);
    },

    getLinkSettings: function() {
        var is_shared            = this.$el.find('.is-shared').hasClass('switch-on');
        var allow_public_comment = this.$el.find('.allow-public-comment').hasClass('switch-on');
        var allow_video_feedback = (this.model.isDesign() || this.model.isPdf()) && this.$el.find('.allow-video-feedback').hasClass('switch-on');
        var apply_to_all         = this.$el.find('input[name="apply_to_all"]').prop('checked');

        return {
            is_shared            : is_shared,
            allow_public_comment : allow_public_comment,
            allow_video_feedback : allow_video_feedback,
            apply_to_all         : apply_to_all
        };
    },

    getApprovalSettings: function() {
        var user_ids = [];

        this.$el.find('.approver-row.selected').each(function() {
            user_ids.push(parseInt($(this).data('id'), 10));
        });

        return {
            user_ids: user_ids,
            notify: this.$el.find('.approver-row.selected input[name="notify_approver"]').prop('checked')
        };
    },

    renderApprovers: function() {
        if (!this.model.isDesign()) {
            return;
        }

        var approvers = '';
        _.each(Cache.app.getUsersByProject(Cache.default_project_id), function(user) {
            var is_approver = Cache.feedback_approver.findWhere({feedback_id: this.model.id, user_id: user.id}) ? true : false;
            var uid = _.uniqueId('na_');

            var workspace_member = Cache.workspace_member.findWhere({user_id: user.id});

            approvers += '<div class="approver-row' + (is_approver ? ' selected' : '') + '" data-id="' + user.id + '">' +
                                '<img class="user-32" src="' + user.getAvatar(32) + '">' +
                                '<div>' +
                                    '<div class="name">' +
                                        user.escape('name') +
                                        (workspace_member && workspace_member.get('role') === Constants.ADMIN    ? '<span class="badge-small badge-secondary-invert">Admin</span>' : '') +
                                        (workspace_member && workspace_member.get('role') === Constants.ASSIGNEE ? '<span class="badge-small badge-secondary-invert">Collaborator</span>' : '') +
                                        (workspace_member && workspace_member.get('role') === Constants.CLIENT   ? '<span class="badge-small badge-secondary-invert">Guest</span>' : '') +
                                    '</div>' +
                                    '<div class="email">' + user.escape('email') + '</div>' +
                                '</div>' +

                                '<div class="notify-approver">' +
                                    '<input type="checkbox" name="notify_approver" id="' + uid + '">' +
                                    '<label for="' + uid + '">Notify the approver by email</label>' +
                                '</div>' +

                            '</div>';
        }, this);

        Cache.user_invitation.each(function(invitation) {
            approvers += '<div class="approver-row disabled">' +
                                '<img class="user-32" src="' + Util.gravatar(invitation.get('email')) + '">' +
                                '<div>' +
                                '<div class="name">' +
                                'Pending invitation' +
                                    (invitation.get('role') === Constants.ADMIN    ? '<span class="badge-small badge-secondary-invert">Admin</span>' : '') +
                                    (invitation.get('role') === Constants.ASSIGNEE ? '<span class="badge-small badge-secondary-invert">Collaborator</span>' : '') +
                                    (invitation.get('role') === Constants.CLIENT   ? '<span class="badge-small badge-secondary-invert">Guest</span>' : '') +
                                '</div>' +
                                '<div class="email">' + invitation.escape('email') + '</div>' +
                                '</div>' +
                            '</div>';
        });

        this.$el.find('.approver-scroller').html(approvers);
    },

    renderPublicAccessHelp: function() {
        var is_shared = this.$el.find('.is-shared').hasClass('switch-on');
        var allow_public_comment = this.$el.find('.allow-public-comment').hasClass('switch-on');

        var share_help_text = '';
        var public_comment_help_text = '';

        if (is_shared) {
            share_help_text = 'Anyone with the share link can view the ' + (this.model.isDesign() || this.model.isPdf() ? 'design' : 'feedback') + '.';
        } else {
            share_help_text = 'Only logged-in users in this project can view the ' + (this.model.isDesign() || this.model.isPdf() ? 'design' : 'feedback') + '.';
        }

        if (allow_public_comment) {
            public_comment_help_text = 'Anyone with the share link can comment on the ' + (this.model.isDesign() || this.model.isPdf() ? 'design' : 'feedback') + '.';
        } else {
            public_comment_help_text = 'Only logged-in users in this project can comment on the ' + (this.model.isDesign() || this.model.isPdf() ? 'design' : 'feedback') + '.';
        }

        this.$el.find('.public-access-help').text(share_help_text);
        this.$el.find('.public-comment-help').text(public_comment_help_text);
    },

    render: function() {
        var content = '';

        var viewer_link  = window.location.origin + '/viewer/' + Cache.account.id + '/' + this.model.get('project_id') + '/' + this.model.escape('share_key') + '/';
        var portal       = Cache.portal.findWhere({project_id: Cache.default_project_id});
        var is_on_portal = portal && portal.isFeedbackVisible(this.model);

        var content = '<div class="tab">' +
                            '<div class="tab-menu">' +
                                (this.hide_share ? '' :
                                '<a href="#" data-type="share" class="active">Share Link</a>') +

                                '<a href="#" data-type="settings"' + (this.hide_share ? ' class="active"' : '') + '>Settings</a>' +

                                (this.model.isDesign() ?
                                '<a href="#" data-type="approval">Request Approval</a>' : '') +
                            '</div>' +
                            '<div class="tab-content">' +
                                (this.hide_share ? '' :
                                '<div class="active">' +
                                    '<div>' +
                                        'Copy this private link to share: (<a class="new-window-link" href="' + viewer_link + '" target="_blank">open in new window</a>)' +
                                        '' +
                                    '</div>' +

                                    '<div class="box-url-share margin-top-8">' + viewer_link + '</div> ' +

                                    '<div class="copy-success">Link copied <i class="fas fa-check-circle"></i></div>' +

                                    '<div class="share-method-divider"><div class="hr small"><span>or</span></div></div>' +

                                    '<p>Email this link to share:</p>' +
                                    '<form class="copy-input">' +
                                        '<div class="margin-bottom-0">' +
                                            '<input type="text" name="email" placeholder="jason@example.com" maxlength="400" required autofocus>' +
                                        '</div>' +
                                        '<button class="primary medium email-send">Send</button>' +
                                    '</form>' +

                                    (Cache.account.isFreePlan() || Cache.account.get('is_trial') ? '' :
                                    '<div class="add-email-note">' +
                                        '<span>Add a message</span><i class="far fa-angle-down"></i>' +
                                    '</div>' +
                                    '<div class="email-note margin-top-8">' +
                                        '<textarea name="note" class="solid compact" placeholder="Add a message" style="height:90px;"></textarea>' +
                                    '</div>') +
                                '</div>') +

                                '<div' + (this.hide_share ? ' class="active"' : '') + '>' +
                                    '<div class="flex-between">' +
                                        '<div>' +
                                            '<div class="font-weight-medium">Allow public access</div>' +
                                            '<div class="text-info text-small margin-top-8">' +
                                                '<div class="public-access-help"></div>' +
                                                (is_on_portal ?
                                                '<div class="margin-top-8"><i class="fas fa-info-circle"></i> Public access can\'t be turned off for ideas on your ideas portal.</div>' :
                                                '') +
                                            '</div>' +
                                        '</div>' +
                                        '<div>' +
                                            '<button class="is-shared small ' + ((this.model.get('is_shared') || is_on_portal) ? 'switch-on' : 'switch-off') + '"' + (portal && portal.isFeedbackVisible(this.model) ? ' disabled' : '') + '></button>' +
                                        '</div>' +
                                    '</div>' +
                                    '<hr class="small">' +
                                    '<div class="flex-between">' +
                                        '<div>' +
                                            '<div class="font-weight-medium">Allow public commenting</div>' +
                                            '<div class="text-info text-small margin-top-8 public-comment-help"></div>' +
                                        '</div>' +
                                        '<div>' +
                                            '<button class="allow-public-comment small ' + (this.model.get('allow_public_comment') ? 'switch-on' : 'switch-off') + '"></button>' +
                                        '</div>' +
                                    '</div>' +

                                    (this.model.isDesign() || this.model.isPdf() ?
                                    '<hr class="small">' +
                                    '<div class="flex-between">' +
                                        '<div class="font-weight-medium">' +
                                            'Video feedback' +
                                        '</div>' +
                                        '<div>' +
                                            '<button type="button" class="allow-video-feedback switch-on"></button>' +
                                        '</div>' +
                                    '</div>' : '') +

                                    '<hr class="small">' +
                                    '<div class="apply-to-all float-left margin-top-24">' +
                                        '<input type="checkbox" name="apply_to_all" id="apply_to_all">' +
                                        '<label for="apply_to_all">Apply to all current and future feedback</label>' +
                                    '</div>' +

                                    '<div class="text-align-right margin-top-32">' +
                                        '<button class="primary settings-save" disabled>Save</button>' +
                                    '</div>' +
                                '</div>' +

                                (this.model.isDesign() ?
                                '<div class="position-relative">' +
                                    '<div class="font-weight-medium">Select an approver</div>' +
                                    '<div class="info text-small margin-top-8">Approvers can login and approve your design with the click of a button.</div>' +
                                    '<div class="approver-scroller' + (this.model.isPdf() || this.model.isVideoUpload() ? ' approver-scroller-large' : '') + '"></div>' +

                                    '<div>' +
                                        '<i class="far fa-plus text-primary"></i> <a href="#" class="invite-people primary underline">Invite user or client to this project</a>' +
                                    '</div>' +

                                    '<div class="text-align-right margin-top-24">' +
                                        '<button class="primary approver-save" disabled>Save</button>' +
                                    '</div>' +
                                '</div>' : '') +
                            '</div>' +
                        '</div>';

        this.$el.html(content);

        this.renderApprovers();
        this.renderPublicAccessHelp();

        return this;
    }
});

export default Feedback_Share;
